import React from 'react';
import {connect} from "react-redux";
import {compose} from "redux";
import SearchObjectsContainer from "../components/common/SearchObjects/SearchObjectsContainer";
import {getObjectIdSelector} from "../components/CalendarBusy/selectors";
import {getObjectsSelector} from "../components/Objects/selectors";
import {getUserRoleSelector} from "../globalState/app/selectros";



export const WithModeratorSearchHOC = (Component) => {

    const ModeratorSearchComponent = (props) => {
        const {userRole} = props
        let querySearchObjectId = props.match.params.objectId


        if (userRole === "MODERATOR" && !querySearchObjectId) {

            return <div className="main">
                <div className="container-fluid">
                    <SearchObjectsContainer/>
                </div>
            </div>
        }

        return <Component {...props} />

    }


    let mapStateToProps = (state, props) => {
        let querySearchObjectId = getUserRoleSelector(state) === "MODERATOR" || props.path.includes("bookings") ? props.match.params.objectId : null

        return {
            objects: getObjectsSelector(state),
            objectId: querySearchObjectId ? querySearchObjectId : getObjectIdSelector(state),
            userRole: getUserRoleSelector(state),
            verified: state.user.verified
        }
    }


    return compose(connect(mapStateToProps, {}))(ModeratorSearchComponent)
}
